<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="ch-info-component">
      <v-flex xs12>
        <v-card>
          <v-card-title class="head">
            <v-layout row wrap>
              <v-flex xs12>
                <i class="fas fa-user-circle fa-fw"></i>
                <span class="info-name ml-2">{{ (name !== null) ? name : 'None' }}</span>
                <span class="info-id ml-2"><b>[</b> {{ (domain_name !== null) ? domain_name : 'None' }} <b>]</b></span>
                <button class="ml-2" @click="copyText">
                  <i class="far fa-clone"></i>
                </button>
                <span class="box">
                  <span class="name">UPDATED</span>
                  <span class="time">{{ updated_at }}</span>
                </span>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="body ch-info-field-border">
            <v-layout row wrap class="ch-info-field-wrapper ma-0 pb-3">
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-user fa-fw"></i>
                    <span class="ml-2">NAME</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="name"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-envelope-square fa-fw"></i>
                    <span class="ml-2">EMAIL</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="email"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-file-alt fa-fw"></i>
                    <span class="ml-2">DESCRIPTION</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="desc"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-key fa-fw"></i>
                    <span class="ml-2">PASSWORD</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0 ch-input-pwd"
                      v-model="password"
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <div class="ch-info-field">
                  <div class="ch-info-field-title">
                    <i class="fas fa-calendar-check fa-fw"></i>
                    <span class="ml-2">CREATED AT</span>
                  </div>
                  <div class="ch-info-field-body">
                    <v-text-field
                      class="pt-0"
                      v-model="created_at"
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <div class="btn-wrapper">
              <router-link :to="{name: 'admins'}">
                <button class="ch-menu-btn ch-menu-backbtn" type="button">
                  <i class="fas fa-angle-left fa-fw"></i>
                  LIST
                </button>
              </router-link>
              <v-spacer></v-spacer>
              <button
                class="save"
                @click="updateAdmin"
                :disabled="!isValid"
              >
                <i class="fas fa-save fa-fw"></i>
                <span>SAVE</span>
              </button>
              <button
                class="delete"
                @click="openDeleteDialog"
              >
                <i class="fas fa-times-circle fa-fw"></i>
                <span>DELETE</span>
              </button>
              <!-- NOTE: Delete Dialog -->
              <v-dialog v-model="deleteDialog" max-width="300">
                <v-card>
                  <v-card-title class="headline">Are you sure you want to delete the admin account?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error darken-1" flat="flat" @click.native="deleteDialog = false">Cancel</v-btn>
                    <v-btn color="primary darken-1" flat="flat" @click.native="deleteAdmin">Delete</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import api from '../../../api';

  export default {
    data() {
      return {
        id: null,
        email: null,
        password: null,
        name: null,
        desc: null,
        api_key: null,
        domainItems: [],
        domain_name: '',
        created_at: null,
        updated_at: null,
        // NOTE: Dialog
        createDialog: false,
        deleteDialog: false,
        // NOTE: validation
        rules: {
          required: value => !!value || 'Required.',
          email: (value) => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'Invalid e-mail.';
          },
        },
      };
    },
    methods: {
      getAdminDetail() {
        api.getAdminDetail(this.id)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
          // NOTE: 삭제된 아이템
          if (err.response.status === 404) {
            console.error('Invalid page', err.response);
            this.$router.push({ name: 'admins' });
          }
        });
      },
      updateAdmin() {
        const id = this.id;
        const params = {
          name: this.name,
          email: this.email,
          desc: this.desc,
          password: this.password || undefined,
        };
        api.updateAdmin(id, params)
        .then((result) => {
          if (result.status === 200) {
            Object.assign(this, result.data);
            this.created_at = this.$moment(result.data.created_at).format('YYYY-MM-DD HH:mm:ss');
            this.updated_at = this.$moment(result.data.updated_at).format('YYYY-MM-DD HH:mm:ss');
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Save';
            this.alertOccur();
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      // NOTE: delete admin
      deleteAdmin() {
        const id = this.id;
        api.deleteAdmin(id)
        .then((result) => {
          if (result.status === 200) {
            this.alert.type = 'check_circle';
            this.alert.color = 'green';
            this.alert.message = 'Success Delete';
            this.alertOccur();
            this.$router.push({ name: 'admins' });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      isValid() {
        // NOTE: 비밀번호가 사용되었을 때
        if (this.password !== null) {
          if ((this.name !== '') || (this.password !== '') || (this.desc !== '')) {
            return true;
          }
        }
        // NOTE: 비밀번호가 사용되지 않았을 때
        if (this.password === null) {
          return true;
        }
        return false;
      },
      openDeleteDialog() {
        this.deleteDialog = true;
      },
      /**
       * @description 정보창 상단 타이틀 복사
       */
      copyText() {
        const copyTextInfo = document.createElement('input');
        const body = document.getElementsByTagName('body')[0];
        body.appendChild(copyTextInfo);
        copyTextInfo.value = this.domain_name;
        copyTextInfo.select();
        document.execCommand('Copy');
        copyTextInfo.remove();
        this.alert.type = 'check_circle';
        this.alert.color = 'green';
        this.alert.message = 'Copied';
        this.alertOccur();
      },
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getAdminDetail();
    },
    created() {
      this.visibleDomain = localStorage.getItem('domain_type') === 'root';
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/admins/AdminsDetailInfo.vue